import { ConvexError } from 'convex/values'

/** Only application error payloads are safe to display; server messages may contain traces. */
export function errorText(error: unknown) {
  if (error instanceof ConvexError) {
    if (typeof error.data === 'string') return error.data
    if (error.data && typeof error.data === 'object' && 'message' in error.data && typeof error.data.message === 'string')
      return error.data.message
  }
  return 'Something went wrong. Please try again.'
}
